<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (pageLoading1 || pageLoading2) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
<div class="row">
	<div class="col">
		<div class="card">
			<div class="card-header">
				<h5 class="card-title mb-0">
					{{pagetitle}}
					@if (caseDetails?.mark_for_closure) {
					<span class="float-end text-dark me-3 mt-1">
						<fa-icon [icon]="['fas',caseDetails?.mark_for_closure?'check-square':'square']"
							[ngClass]="caseDetails?.mark_for_closure?'text-success':'text-custom'"
							class="mark-for-closure">
						</fa-icon>
						Marked for closure
					</span>
					}
					<span class="float-end text-dark me-3 mt-1">
						Case-Id:
						<strong>
							{{caseDetails?.case_id}}
						</strong>
					</span>
					<span class="float-end text-dark me-3 mt-1">
						<strong>
							<fa-icon [icon]="['fas',caseDetails?.status==2?'lock':'lock-open']"
								[matTooltip]="caseDetails?.case_status">
							</fa-icon>
						</strong>
					</span>
				</h5>
			</div>
			<div class="card-body">
				<div class="row mb-2">
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Name&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.f_name}} {{caseDetails?.l_name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>DOB&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.dob || "___"}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Rank&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.rank_name || "___"}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Vessel&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.vessel || "___"}}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<mat-accordion [hideToggle]="false" [multi]="true">
	@for (item of allBillFiles; track $index) {
	<mat-expansion-panel [expanded]="true" class="mb-2">
		<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'" [expandedHeight]="'40px'">
			<mat-panel-title>
				<strong class="text-white">
					{{item.date}}
					:&nbsp;
					{{item.category__name}}
				</strong>
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>
		@for (file of item.files; track $index) {
		<div class="card mt-1">
			<div class="card-header bg-light mb-0">
				<h5 class="card-title pt-1 text-secondary mb-0">
					{{getFileName(file)}}
				</h5>
			</div>
			<div class="card-body mt-0 p-1" style="overflow:auto">
				@if (checkImage(file)) {
				<img [src]="File_Storage_URL+file" />
				}
				@if (checkPdf(file)) {
				<pdf-viewer [src]="File_Storage_URL+file" [render-text]="true" [original-size]="true"
					[show-borders]="true" style="width: 100%;"></pdf-viewer>
				}
			</div>
		</div>
		}
	</mat-expansion-panel>
	}
</mat-accordion>
@if (!allBillFiles.length) {
<div class="card mt-1">
	<div class="card-body">
		<h3 class="text-center fw-bold">No Files</h3>
	</div>
</div>
}
<br />